import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetChartEnps state domain
 */

const selectWidgetChartEnpsDomain = (state) =>
  state.get("widgetChartEnps", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectWidgetChartEnpsDomain, (state) => state.get("isLoading"))

export const makeSelectDataEnps = () =>
  createSelector(selectWidgetChartEnpsDomain, (state) => state.get("dataEnps"))

const makeSelectWidgetChartEnps = () =>
  createSelector(selectWidgetChartEnpsDomain, (substate) => substate.toJS())

export default makeSelectWidgetChartEnps
export { selectWidgetChartEnpsDomain }
